import React, { useRef, useState, useEffect } from "react";
import {

  onSnapshot,


  getDoc,
  doc,
} from "firebase/firestore";
import { db } from "../../../config/firebase";

import orderSuccessImg from "../../../assets/images/ordersuccess.svg";
import formatDate from "../../../utils/formatDate";

import SelectOrder from "./SelectOrder";
import generateUniqueId from "../../../utils/generateId";

function Orderchoose(props) {
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [hasSelection, setHasSelection] = useState(false);
  const [activeId, setActiveId] = useState(undefined);
  const [uid, setUid] = useState("newuser123");
  //   const { currentUser } = useAuth();
  // const { uid } = currentUser;
 
  const urlParams = new URLSearchParams(window.location.search);
  const currentDomain = urlParams.get("parentUrl");

  useEffect(() => {
    
    const uid_name=currentDomain+"uid"
    const existingUid = localStorage.getItem(uid_name);
    if (!existingUid) {
      const newUid = generateUniqueId();

      localStorage.setItem("uid", newUid);
      setUid(newUid);
    } else {
      setUid(existingUid);
    }
    var docid = "";
    const stored_data_var= currentDomain+"myData"
    const storedData = localStorage.getItem(stored_data_var);
    

    if (!storedData) {
      // If the data is not already stored, set the initial data
      const initialData = { key: uid + Date.now().toString() };

      localStorage.setItem("myData", JSON.stringify(initialData));
     
      docid = initialData.key;
    } else {
      // If the data is already stored, log it
      const parsedData = JSON.parse(storedData);
    
      docid = parsedData.key;
    }
    const fetchData = async () => {
      const docRef = doc(db, "Messages", docid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const docmessage = docSnap.data().Orders;
      
        if (docmessage !== undefined) {
          if (Array.isArray(docmessage)) {
            setOptions(docmessage);
         
          } else {
            console.error("Orders is not an array:", docmessage);
          }
        }
      }
    };

    fetchData();
    const docRef = doc(db, "Messages", docid);
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists) {
        var data = docSnap.data();
        if (data !== undefined) {

          if ("Orders" in data) {
           
            const docmessage = docSnap.data().Orders;
            if (Array.isArray(docmessage)) {
              setOptions(docmessage);
            } else {
              console.error("Orders is not an array:", docmessage);
            }
          }
        }
      } else {
        // The document doesn't exist
        console.log("Document does not exist");
      }
    });
    return () => unsubscribe();
  }, []);



 
  return (
    <div>
    <div className="krunk-order-bg krunk-w-full  krunk-rounded-2xl krunk-my-5 krunk-pt-1 krunk-px-3 krunk-pb-3">
      {!selectedValue ? (
        <p className="krunk-py-2 ">Which item do you need help with ?</p>
      ) : (
        <p className="krunk-py-2 ">Confirm your order</p>
      )}
  
      {!selectedValue && options.length !== 0 && (
        <div className="krunk-flex krunk-items-center krunk-gap-2 ">
          <p>
            Showing:
            <span className="krunk-ml-2">Last {options.length} orders</span>
          </p>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/web_icons%2FdownArrow.svg?alt=media&token=6b068593-5c57-4be8-9eb2-520ea57b3ea4"
            alt="open"
          />
        </div>
      )}
      {selectedValue ? (
        <SelectOrder
          selectedOrder={selectedValue}
          setSelectedValue={setSelectedValue}
        />
      ) : (
        <div className="krunk-space-y-2 krunk-mt-2">
          {options &&
            options.length !== 0 &&
            options.map((option, i) => {
              const isActive = option?.OrderID === activeId;
              return (
                <div key={i} className="krunk-space-y-2">
                  <button
                    className="krunk-mx-auto krunk-rounded-xl krunk-w-full krunk-flex krunk-items-center krunk-justify-between krunk-bg-white krunk-px-4 krunk-py-3 krunk-text-sm"
                    onClick={() => setActiveId(option.OrderID)}
                  >
                    <span className="krunk-font-semibold">
                      ₹ {option.TotalCost}
                    </span>
                    <span className="krunk-text-secondary krunk-text-[12px]">
                      {option.Items.length} items,&nbsp;
                      {formatDate(option.ShippingDate)}
                    </span>
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/web_icons%2FdownArrow.svg?alt=media&token=6b068593-5c57-4be8-9eb2-520ea57b3ea4"
                      alt="^"
                    />
                  </button>
  
                  {isActive && (
                    <div className="krunk-bg-white krunk-w-full krunk-px-4 krunk-rounded-2xl krunk-py-2 krunk-transform krunk-duration-200">
                      <div className="krunk-text-sm krunk-font-semibold krunk-flex krunk-items-center krunk-justify-between">
                        ORDER ID: {option?.OrderID}
                        <img
                          src="https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/web_icons%2FdownArrow.svg?alt=media&token=6b068593-5c57-4be8-9eb2-520ea57b3ea4"
                          alt=""
                          onClick={() => setActiveId(undefined)}
                          className={"krunk-cursor-pointer krunk-rotate-180"}
                        />
                      </div>
                      <div className="krunk-flex krunk-items-center krunk-gap-2 krunk-py-2">
                        {option.image_url?.map((url, i) => (
                          <img
                            src={url}
                            key={i}
                            className="krunk-rounded-lg krunk-w-[50px]"
                            alt={i + "product"}
                          />
                        ))}
                      </div>
                      <p className="krunk-font-semibold">₹ {option.TotalCost}</p>
                      <div className="krunk-flex krunk-items-center krunk-justify-start krunk-gap-1 krunk-py-1 krunk-text-secondary">
                        <img src={orderSuccessImg} alt="" />
                        <p className="krunk-text-sm">
                          {option.Items.length} items on {option.ShippingDate}
                        </p>
                      </div>
                      <button
                        className="krunk-my-2 krunk-py-2 krunk-px-4 krunk-rounded-xl krunk-border krunk-font-semibold krunk-border-primary1 krunk-text-primary1 krunk-w-full"
                        onClick={() => setSelectedValue(option)}
                      >
                        View Items
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      )}
    </div>
  </div>
  
  );
}

export default Orderchoose;
